import { render, staticRenderFns } from "./Jugadores.vue?vue&type=template&id=cce5e664&scoped=true"
import script from "./Jugadores.vue?vue&type=script&lang=js"
export * from "./Jugadores.vue?vue&type=script&lang=js"
import style0 from "./Jugadores.vue?vue&type=style&index=0&id=cce5e664&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cce5e664",
  null
  
)

export default component.exports